import * as Yup from 'yup'

const forgotPasswordSchema = Yup.object({
  email: Yup.string().email('Insira um e-mail válido').required('O e-mail é obrigatório')
})

export default forgotPasswordSchema
